/* ═══ A APRESENTAÇÃO DE MARCA — as mecânicas do formato D [2026-09-01] ═══════
   Quatro movimentos, todos por transform/opacity, sem biblioteca:
   1. a capa abre em zoom e assenta conforme a rolagem (scroll-zoomin);
   2. o texto acende palavra a palavra no ritmo do dedo (text-reveal);
   3. o número conta quando entra em cena;
   4. cada capítulo se aproxima ao chegar (classe .viva).
   🔑 Quem pede menos movimento (prefers-reduced-motion) recebe a página
     parada e INTEIRA — o texto nem é fatiado em palavras.
   🪤 O texto fatiado usa textContent: formatação em HTML dentro do campo
     se perde de propósito — o campo do editor é texto puro. */
(function () {
  'use strict';
  var raiz = document.querySelector('[data-apresenta]');
  if (!raiz) return;
  var calmo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fita = document.querySelector('[data-ap-fita]');

  var textos = [].slice.call(raiz.querySelectorAll('[data-acende]'));
  if (!calmo) textos.forEach(function (t) {
    t.innerHTML = t.textContent.trim().split(/\s+/).map(function (w) {
      return '<span>' + w + '</span>';
    }).join(' ');
  });

  var capa = raiz.querySelector('.ap-capa');
  /* [2026-09-07] a capa pode ser vídeo (escolha dele: H1 e M2 = B); o zoom vale para os dois */
  var capaImg = capa && capa.querySelector('video, img');

  /* [2026-09-07] escolha dele (C3 = B): o WhatsApp flutuante some enquanto a
     capa está na tela. Quem esconde é o CSS, pela classe no body. */
  if (capa && window.IntersectionObserver) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { document.body.classList.toggle('ap-capa-na-tela', e.isIntersecting); });
    }, { threshold: 0.15 }).observe(capa);
  }

  /* [2026-09-07] o giro 360 dentro dos passos (escolha dele: T2 = B) — a mesma
     mecânica do giro da ficha (ettore-produto-js): arrastar troca o quadro. */
  [].forEach.call(raiz.querySelectorAll('[data-giro]'), function (giro) {
    var qs = giro.querySelectorAll('.gq');
    if (!qs.length) return;
    qs[0].classList.add('on');
    var atual = 0, arrastando = false, x0 = 0, base = 0;
    var mostra = function (i) {
      i = ((i % qs.length) + qs.length) % qs.length;
      if (i === atual) return;
      qs[atual].classList.remove('on'); qs[i].classList.add('on'); atual = i;
    };
    giro.addEventListener('pointerdown', function (e) { arrastando = true; x0 = e.clientX; base = atual; giro.setPointerCapture(e.pointerId); });
    giro.addEventListener('pointermove', function (e) { if (arrastando) mostra(base + Math.round((e.clientX - x0) / giro.clientWidth * qs.length)); });
    giro.addEventListener('pointerup', function () { arrastando = false; });
    giro.addEventListener('pointercancel', function () { arrastando = false; });
    giro.tabIndex = 0;
    giro.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { mostra(atual + 1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { mostra(atual - 1); e.preventDefault(); }
    });
  });

  /* [2026-09-09] O PALCO PRESO — o bloco 'passos'. Base: o scroll-01 do
     21st.dev, com a correção dele: *"fica um texto só, do lado. Você scrolla,
     troca a imagem, troca o texto"*.
     🔑 A CONTA É UMA SÓ: o trilho tem uma tela por passo e o palco fica preso
       dentro dele. Quanto do trilho já passou (0 a 1) vezes o número de passos
       dá a fatia — e a fatia é o passo. Foto e texto trocam no mesmo instante
       porque leem o MESMO índice; é isso que faz parecer um movimento só.
     🪤 O DIVISOR É `altura − uma tela`, não a altura: enquanto o palco está
       preso, o trilho ainda tem uma tela de sobra embaixo. Dividir pela altura
       cheia faria o último passo nunca chegar ao fim.
     🔑 Mora aqui, e não em arquivo próprio, porque `pinta()` JÁ roda a cada
       rolagem — dois ouvintes de scroll é o que faz a rolagem engasgar no
       celular. Vale também para quem pede menos movimento: trocar a foto é
       conteúdo, não enfeite (o CSS é que tira a transição). */
  var rolos = [].slice.call(raiz.querySelectorAll('[data-rolo]')).map(function (r) {
    return {
      trilho: r.querySelector('[data-rolo-trilho]'),
      txts: [].slice.call(r.querySelectorAll('[data-rolo-txt]')),
      paineis: [].slice.call(r.querySelectorAll('[data-rolo-painel]')),
      ativo: 0
    };
  });

  function pintaRolos(vh) {
    rolos.forEach(function (rolo) {
      if (!rolo.trilho || rolo.txts.length < 2) return;
      var r = rolo.trilho.getBoundingClientRect();
      var curso = r.height - vh;
      if (curso <= 0) return;

      var p = Math.max(0, Math.min(1, -r.top / curso));
      var i = Math.floor(p * rolo.txts.length);
      if (i > rolo.txts.length - 1) i = rolo.txts.length - 1;
      if (i === rolo.ativo) return;

      if (rolo.txts[rolo.ativo]) rolo.txts[rolo.ativo].classList.remove('ativo');
      if (rolo.paineis[rolo.ativo]) rolo.paineis[rolo.ativo].classList.remove('ativo');
      rolo.txts[i].classList.add('ativo');
      if (rolo.paineis[i]) rolo.paineis[i].classList.add('ativo');
      rolo.ativo = i;
    });
  }

  function pinta() {
    var vh = window.innerHeight;
    if (fita) {
      var doc = document.documentElement;
      var total = doc.scrollHeight - vh;
      fita.style.width = (total > 0 ? (window.scrollY / total * 100) : 0) + '%';
    }
    pintaRolos(vh);
    if (calmo) return;
    if (capaImg) {
      var r = capa.getBoundingClientRect();
      var t = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height)));
      capaImg.style.transform = 'scale(' + (1.15 - 0.15 * t) + ')';
    }
    textos.forEach(function (tx) {
      var r = tx.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var spans = tx.children;
      var prog = (vh - r.top) / (r.height + vh * 0.55);
      var n = Math.floor(Math.max(0, Math.min(1.15, prog)) * spans.length * 1.15);
      for (var i = 0; i < spans.length; i++) spans[i].style.opacity = i < n ? 1 : '';
    });
  }
  window.addEventListener('scroll', pinta, { passive: true });
  window.addEventListener('resize', pinta, { passive: true });
  pinta();

  [].forEach.call(raiz.querySelectorAll('[data-ap-conta]'), function (el) {
    var alvo = parseInt(el.getAttribute('data-ap-conta'), 10) || 0;
    if (calmo || !window.IntersectionObserver) { el.textContent = alvo; return; }
    var feito = false;
    new IntersectionObserver(function (es, obs) {
      es.forEach(function (e) {
        if (e.isIntersecting && !feito) {
          feito = true; obs.disconnect();
          var v = 0, passo = Math.max(1, Math.round(alvo / 24));
          var tm = setInterval(function () {
            v += passo;
            if (v >= alvo) { v = alvo; clearInterval(tm); }
            el.textContent = v;
          }, 30);
        }
      });
    }, { threshold: 0.6 }).observe(el);
  });

  /* ═══ A CITAÇÃO SE ESCREVE — [2026-09-09], pedido dele ═══════════════════
     Referência dele: `21st.dev/r/designali-in/typewriter`. React não entra em
     tema Shopify, então o comportamento vem portado, como o text-reveal e o
     scroll-zoomin desta mesma seção.
     🔑 TRÊS COISAS SÃO DIFERENTES DO COMPONENTE, de propósito:
       1. **Digita UMA VEZ e para.** O original roda em laço: digita, espera,
          APAGA e troca de palavra, para sempre. Numa citação assinada isso
          apagaria a frase do fundador a cada 2s — o efeito serve à entrada,
          não à repetição.
       2. **Dispara ao entrar na tela**, não no carregamento. A página inteira é
          movida pela rolagem; começar escondido desperdiçaria o efeito.
       3. **38ms por caractere**, não os 100 do original: a frase tem 80
          caracteres e a 100ms levaria 8s. A 38ms fecha em ~3s.
     🪤 A FRASE JÁ VEM ESCRITA no HTML e o JS a apaga para redigitar — assim,
       sem JS ou com `prefers-reduced-motion`, ela aparece inteira e o autor
       junto. Nunca se depende do script para o texto existir.
     🪤 A altura se reserva ANTES de esvaziar, e depois de `document.fonts.ready`:
       medir com a fonte de reserva dá altura errada, e sem reservar a frase
       cresce linha a linha e empurra o autor — o pulo apareceria em toda visita. */
  [].forEach.call(raiz.querySelectorAll('.ap-citacao'), function (bq) {
    var p = bq.querySelector('p');
    if (!p) return;
    var alvo = (p.textContent || '').trim();
    if (!alvo || calmo || !window.IntersectionObserver) return;
    var pronto = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
    pronto.then(function () {
      p.style.minHeight = Math.ceil(p.getBoundingClientRect().height) + 'px';
      var cur = document.createElement('i');
      cur.className = 'cur';
      cur.setAttribute('aria-hidden', 'true');
      cur.textContent = '|';
      var feito = false;
      new IntersectionObserver(function (es, obs) {
        es.forEach(function (e) {
          if (!e.isIntersecting || feito) return;
          feito = true; obs.disconnect();
          bq.setAttribute('data-escrevendo', '');
          p.textContent = '';
          p.appendChild(cur);
          var i = 0;
          var tm = setInterval(function () {
            i++;
            if (cur.parentNode) p.removeChild(cur);
            p.textContent = alvo.slice(0, i);
            p.appendChild(cur);
            if (i >= alvo.length) {
              clearInterval(tm);
              setTimeout(function () {
                if (cur.parentNode) p.removeChild(cur);
                bq.removeAttribute('data-escrevendo');
              }, 900);
            }
          }, 38);
        });
      }, { threshold: 0.55 }).observe(bq);
    });
  });

  var zooms = [].slice.call(raiz.querySelectorAll('.ap-zoom'));
  if (calmo || !window.IntersectionObserver) {
    zooms.forEach(function (z) { z.classList.add('viva'); });
  } else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('viva'); io.unobserve(e.target); }
      });
    }, { threshold: 0.2 });
    zooms.forEach(function (z) { io.observe(z); });
  }
})();
